<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Cadastrar Grupo de Apoio</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite o nome da grupo:"
              v-model="state.grupo.nome.value"
            />
            <span v-if="state.grupo.nome.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="conselho">Link</label>
            <input
              id="conselho"
              type="text"
              class="form-control"
              placeholder="Digite um nome:"
              v-model="state.grupo.link.value"
            />
            <span
              v-if="state.grupo.link.error"
              class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvar" type="button" class="btn_save">Salvar</button>
          <router-link to="/grupos-apoio">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      grupo: {
        nome: {
          value: "",
          error: false,
        },
        link: {
          value: "",
          error: false,
        },
        id: "",
      },
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetch();
      }
    });
    async function fetch() {
      try {
        const { data } = await services.grupos_apoio.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.grupo.id = data.id;
        state.grupo.nome.value = data.nome;
        state.grupo.link.value = data.link;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvar() {
      var erro_validacao = false;

      if (state.grupo.nome.value.length == 0) {
        state.grupo.nome.error = true;
        erro_validacao = true;
      }
      if (state.grupo.link.value.length == 0) {
        state.grupo.link.error = true;
        erro_validacao = true;
      }

      if (erro_validacao == true) {
        return;
      }
      if (!state.grupo.id) {
        try {
          await services.grupos_apoio.save({
            link: state.grupo.link.value,
            nome: state.grupo.nome.value,
            token,
          });
          router.push({ name: "GruposApoio" });
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          await services.grupos_apoio.update({
            id: state.grupo.id,
            link: state.grupo.link.value,
            nome: state.grupo.nome.value,
            token,
          });
          router.push({ name: "GruposApoio" });
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      salvar,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #47b0a9;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #47b0a9;
}
.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  margin-top: 30px;
  transition: 0.2s;
}
.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}
tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}
thead {
  color: #000;
  text-align: center;
  background: gray;
}
td {
  color: #000;
  text-align: center;
}
.table {
  margin-top: 2rem;
}
.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}
</style>